    (() => {
      if (window.PawmoreFursweepMarketingStackLoaded) return;
      window.PawmoreFursweepMarketingStackLoaded = true;
      const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const viewportVideoObservers = new WeakMap();

      const initBeforeAfter = (root = document) => {
        root.querySelectorAll('[data-pawmore-before-after]').forEach((frame) => {
          if (frame.dataset.pawmoreBeforeAfterReady === 'true') return;
          const range = frame.querySelector('[data-pawmore-before-after-range]');
          if (!range) return;

          const update = () => {
            const parsedValue = Number(range.value);
            const value = Number.isFinite(parsedValue) ? Math.max(0, Math.min(100, parsedValue)) : 50;
            frame.style.setProperty('--pawmore-ba-position', `${value}%`);
          };

          const setFromClientX = (clientX) => {
            const rect = frame.getBoundingClientRect();
            if (!rect.width) return;

            const value = Math.round(((clientX - rect.left) / rect.width) * 100);
            range.value = String(Math.max(0, Math.min(100, value)));
            update();
          };

          let pointerActive = false;
          range.addEventListener('input', update, { passive: true });
          frame.addEventListener('pointerdown', (event) => {
            if (event.isPrimary === false) return;
            if (event.button !== undefined && event.button !== 0) return;

            pointerActive = true;
            setFromClientX(event.clientX);

            if (typeof frame.setPointerCapture === 'function') {
              frame.setPointerCapture(event.pointerId);
            }
          });
          frame.addEventListener('pointermove', (event) => {
            if (event.isPrimary === false) return;
            if (!pointerActive && event.pointerType !== 'mouse') return;
            setFromClientX(event.clientX);
          });
          ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((eventName) => {
            frame.addEventListener(eventName, () => {
              pointerActive = false;
            });
          });
          update();
          frame.dataset.pawmoreBeforeAfterReady = 'true';
        });
      };

      const isMobileHeroJump = () => window.matchMedia('(max-width: 767px)').matches;

      const getHeroTarget = () => {
        const productDetails = document.querySelector('#pawmore-product-details');
        if (!productDetails) return null;

        if (isMobileHeroJump()) {
          return (
            productDetails.querySelector('.shop-product-title')
            || productDetails.querySelector('.pawmore-product-details__info')
            || productDetails
          );
        }

        return productDetails;
      };

      const getHeroScrollTop = () => {
        const target = getHeroTarget();
        if (!target) return null;

        const announcement = document.querySelector('.shopify-section.announcement-bar');
        const announcementRect = announcement?.getBoundingClientRect();
        const announcementBottom = announcementRect && announcementRect.height > 0
          ? Math.max(0, announcementRect.bottom)
          : 0;
        const targetGap = isMobileHeroJump() ? 5 : 0;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset;

        return Math.max(0, targetTop - announcementBottom - targetGap);
      };

      const jumpToHero = (event) => {
        const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
        const trigger = eventTarget?.closest('[data-pawmore-hero-jump]');
        if (!trigger) return;

        const initialTop = getHeroScrollTop();
        if (initialTop === null) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        const html = document.documentElement;
        const body = document.body;
        const previousHtmlScrollBehavior = html.style.scrollBehavior;
        const previousBodyScrollBehavior = body ? body.style.scrollBehavior : '';

        html.style.scrollBehavior = 'auto';
        if (body) body.style.scrollBehavior = 'auto';
        window.scrollTo({ top: initialTop, behavior: 'instant' });
        window.requestAnimationFrame(() => {
          const correctedTop = getHeroScrollTop();
          if (correctedTop !== null) {
            window.scrollTo({ top: correctedTop, behavior: 'instant' });
          }
          html.style.scrollBehavior = previousHtmlScrollBehavior;
          if (body) body.style.scrollBehavior = previousBodyScrollBehavior;
        });
      };

      const initHeroJump = () => {
        if (document.documentElement.dataset.pawmoreHeroJumpReady === 'true') return;
        document.addEventListener('click', jumpToHero, { capture: true });
        document.documentElement.dataset.pawmoreHeroJumpReady = 'true';
      };

      const initCustomerDots = (root = document) => {
        root.querySelectorAll('[data-pawmore-customer-track]').forEach((track) => {
          const shell = track.closest('.pawmore-fursweep-marketing-stack__customer-shell');
          if (!shell || shell.dataset.pawmoreCustomerDotsReady === 'true') return;

          const cards = Array.from(track.querySelectorAll('[data-pawmore-customer-card]'));
          const dots = Array.from(shell.querySelectorAll('[data-pawmore-customer-dot]'));
          if (!cards.length || !dots.length) return;

          const setActiveDot = (activeIndex) => {
            dots.forEach((dot, index) => {
              const isActive = index === activeIndex;
              dot.classList.toggle('is-active', isActive);
              if (isActive) {
                dot.setAttribute('aria-current', 'true');
              } else {
                dot.removeAttribute('aria-current');
              }
            });
          };

          const updateDots = () => {
            const trackLeft = track.getBoundingClientRect().left;
            let activeIndex = 0;
            let shortestDistance = Infinity;

            cards.forEach((card, index) => {
              const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
              if (distance < shortestDistance) {
                shortestDistance = distance;
                activeIndex = index;
              }
            });

            setActiveDot(Math.min(activeIndex, dots.length - 1));
          };

          let scrollFrame = null;
          track.addEventListener('scroll', () => {
            if (scrollFrame) return;
            scrollFrame = window.requestAnimationFrame(() => {
              updateDots();
              scrollFrame = null;
            });
          }, { passive: true });

          dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              const card = cards[index];
              if (!card) return;

              card.scrollIntoView({
                behavior: prefersReducedMotion() ? 'auto' : 'smooth',
                block: 'nearest',
                inline: 'start'
              });
              setActiveDot(index);
            });
          });

          window.addEventListener('resize', updateDots);
          updateDots();
          shell.dataset.pawmoreCustomerDotsReady = 'true';
        });
      };

      const resetViewportVideo = (video) => {
        video.pause();

        const seekToStart = () => {
          try {
            video.currentTime = 0;
          } catch {}
        };

        if (video.readyState >= 1) {
          seekToStart();
        } else {
          video.addEventListener('loadedmetadata', seekToStart, { once: true });
        }

        video.dataset.pawmoreViewportPlaying = 'false';
      };

      const playViewportVideo = (video) => {
        if (video.dataset.pawmoreViewportPlaying === 'true') return;
        video.dataset.pawmoreViewportPlaying = 'true';

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            video.dataset.pawmoreViewportPlaying = 'false';
          });
        }
      };

      const initViewportVideos = (root = document) => {
        root.querySelectorAll('[data-pawmore-viewport-video]').forEach((video) => {
          if (video.dataset.pawmoreViewportVideoReady === 'true') return;

          resetViewportVideo(video);
          video.dataset.pawmoreViewportVideoReady = 'true';

          if (prefersReducedMotion()) return;

          if (!('IntersectionObserver' in window)) {
            playViewportVideo(video);
            return;
          }

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
                playViewportVideo(video);
              } else if (!entry.isIntersecting || entry.intersectionRatio <= 0.05) {
                resetViewportVideo(video);
              }
            });
          }, {
            threshold: [0, 0.05, 0.45]
          });

          observer.observe(video);
          viewportVideoObservers.set(video, observer);
        });
      };

      const destroyViewportVideos = (root = document) => {
        root.querySelectorAll('[data-pawmore-viewport-video]').forEach((video) => {
          viewportVideoObservers.get(video)?.disconnect();
          viewportVideoObservers.delete(video);
          resetViewportVideo(video);
          delete video.dataset.pawmoreViewportVideoReady;
        });
      };

      const initMarketingStack = (root = document) => {
        initBeforeAfter(root);
        initHeroJump(root);
        initCustomerDots(root);
        initViewportVideos(root);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initMarketingStack());
      } else {
        initMarketingStack();
      }

      document.addEventListener('shopify:section:load', (event) => initMarketingStack(event.target));
      document.addEventListener('shopify:section:unload', (event) => destroyViewportVideos(event.target));
    })();
